import EmptyState from '@/components/EmptyState';
import { useT } from '@/i18n';
import { Block, Navbar, Page } from 'framework7-react';

// Placeholder shell for the upcoming Action Center. Wired into the sidebar/routes
// now; the actual tooling lands in a follow-up.
function ActionCenterPage() {
  const t = useT();
  return (
    <Page name="action-center">
      <Navbar title={t.nav.actionCenter} />
      <Block>
        <EmptyState
          icon="bolt_fill"
          iconColor="#f59e0b"
          title={t.nav.actionCenter}
          description="This area is coming soon."
        />
      </Block>
    </Page>
  );
}

export default ActionCenterPage;
